module.exports = __webpack_public_path__ + "img/20.c5e87b5f.jpg";